import { render, staticRenderFns } from "./AddAnotherButton.vue?vue&type=template&id=d853799c&"
import script from "./AddAnotherButton.vue?vue&type=script&lang=ts&"
export * from "./AddAnotherButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports